(() => {
  if (customElements.get('pp-policy-page')) return;
  customElements.define('pp-policy-page', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const content = this.querySelector('.pp-policy-content');
      const sidebar = this.querySelector('.pp-policy-sidebar');
      const details = sidebar.querySelector('details');
      const list = sidebar.querySelector('ol');
      const headings = [...content.querySelectorAll('h2,h3')].filter(h => h.textContent.trim());
      if (!headings.length) return;
      const primary = headings;
      primary.forEach((heading, index) => {
        if (!heading.id) {
          const slug = heading.textContent.trim().toLowerCase().replace(/æ/g,'ae').replace(/ø/g,'oe').replace(/å/g,'aa').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
          let id = slug || `afsnit-${index + 1}`, suffix = 2;
          while (document.getElementById(id)) id = `${slug || 'afsnit'}-${suffix++}`;
          heading.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim();
        item.append(link); list.append(item);
      });
      sidebar.hidden = false;
      const mobile = matchMedia('(max-width: 767px)');
      this.breakpoint = mobile;
      this.applyBreakpoint = () => { details.open = !mobile.matches; };
      this.applyBreakpoint();
      mobile.addEventListener('change', this.applyBreakpoint);
      list.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        if (mobile.matches) details.open = false;
        target.tabIndex = -1;
        requestAnimationFrame(() => target.focus({ preventScroll: true }));
      });
    }
    disconnectedCallback() {
      this.breakpoint?.removeEventListener('change', this.applyBreakpoint);
      this.initialized = false;
      this.querySelector('.pp-policy-index ol')?.replaceChildren();
    }
  });
})();
